<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li> -->
              <li class="breadcrumb-item active">Merchant Report</li>
            </ol>
          </div>
          <h4 class="page-title">Merchant Report Management</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Client and Participant link Setup</h4>
          <p class="sub-header">
            Select a participant to link to a client Id.
          </p>

          <div *ngIf="raiseDanger" class="form-group row">
            <ngb-alert type="danger" style="width:100%" [dismissible]="false">
              <strong>Error!</strong> {{error}}
            </ngb-alert>
          </div>

          <div class="form-group row">
            <label class="col-2 col-form-label">Participant</label>
            <div class="col-5">
              <ng-select style="width:100%;" bindLabel="participant" [(ngModel)]="selectedParticipant" [ngModelOptions]="{standalone: true}" [clearable]="false" [searchable]="true">
                <ng-option [value]="participant.id" *ngFor="let participant of allParticipants">
                  {{participant.name}} ({{participant.id}})
                </ng-option>
              </ng-select>
            </div>
            <div class="col-5">
            </div>
          </div>
          <div class="form-group row">
            <label for="merchantNumber" class="col-2 col-form-label">Client Id</label>
            <div class="col-5">
              <input [(ngModel)]="clientId" id="clientId" type="number" style="width:100%;" placeholder="client Id" required class="form-control" maxlength="4">
            </div>
            <div class="col-5">
              <button type="submit" class="btn btn-info waves-effect waves-light" (click)="save()">
                Save <i class="mdi mdi-content-save"></i>
              </button>
            </div>
          </div>


          <div class="row">

            <div class="col-12">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0" style="width: 100%">
                <thead>
                  <tr>
                    <th>Participant</th>
                    <th>ClientId</th>
                    <th class="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let cplink of clientParticipantLinks">
                    <td>{{ cplink.participantName}}({{ cplink.participantId }})</td>
                    <td>{{ cplink.clientId }}</td>
                    <td>
                      <button type="button" *ngIf="canManage" class="btn btn-icon waves-effect waves-light btn-outline-danger fa-pull-right" (click)="delete(cplink)">
                        <i class="mdi mdi-delete"></i>
                        Remove
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody *ngIf="clientParticipantLinks?.length == 0">
                  <tr>
                    <td colspan="6" class="no-data-available">No data available to display!</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> <!-- end container -->
</div>
